import { BrowserRouter as Router, Route, Routes } from 'react-router';
import { DataProvider } from './providers/DataContext';
import Home from './components/Home';
import Report from './pages/Report';
import LiveDashboard from './pages/LiveDashboard';

function App() {
  return (
    <DataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/live" element={<LiveDashboard/>} />
          <Route path="/report" element={<Report/>} />
        </Routes>
      </Router>
    </DataProvider>
  );
}

export default App;
